// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2pssFF6ZinAVCxuQ1xuX4X{display:grid;grid-template-columns:auto 1fr;align-items:center}.zJuQu8NuCgRqkbQ7MKq9y{margin-left:.7rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prices": "_2pssFF6ZinAVCxuQ1xuX4X",
	"original": "zJuQu8NuCgRqkbQ7MKq9y"
};
module.exports = ___CSS_LOADER_EXPORT___;
